import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.payments.CheckConfirmationOfPayee', {
    confirmationOfPayee: 'Confirmation of payee:',
    calculating: 'Calculating...',
    differentBusinessType:
        'The details you have provided for beneficiary closely match those on record. However the entity type is different. Please check the information you have entered and update if necessary.',
    differentBusinessName: 'The details you have provided for the beneficiary closely match those on record.',
    accountSwitched:
        'The details you have provided for beneficiary closely match those on record. However the account has been switched to a different organisation. Please check the information you have entered and update if necessary.',
    noMatch:
        'It has not been possible to check the beneficiary details you have provided.\n\nPlease check the information you have entered and update if necessary',
    providedBeneficiaryDetails: 'Provided Beneficiary Details:',
    suggestedBeneficiaryDetails: 'Suggested Beneficiary Details:',
    name: 'Name',
    copiedToClipboard: 'Copied to clipboard!',
    av100Text: 'The beneficiary details you have provided are exactly the same as the existing beneficiary details.',
    av200Text:
        'The account number and sort code provided for the beneficiary do not match those on record. Please check the information you have entered and update if necessary',
    av201Text:
        'The name you have provided for the beneficiary does not match that on a record.\n\nPlease check the information you have entered and update if necessary',
});
